import { FC } from "react";
import { Asset, AssetTypes } from "lib/types";
import { AssetIframe } from "./enhanced";
import { DisplayLinkAsset } from "./base/link/displayLinkAsset";
import { DisplayTextAsset } from "./base/text/displayTextAsset";
import { DisplayFileAsset } from "./base/file/displayFileAsset";

export const StaticAsset: FC<{ asset: Asset<any> }> = ({ asset }) => {
  switch (asset.type) {
    case AssetTypes.HTML:
      return <AssetIframe data={asset.data.value} />;
    case AssetTypes.LINK:
      return <DisplayLinkAsset asset={asset} />;
    case AssetTypes.FILE:
      return <DisplayFileAsset asset={asset} />;
    case AssetTypes.TEXT:
      return <DisplayTextAsset asset={asset} />;
    default:
      return null;
  }
};
